(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionDetailController', SSFuncionDetailController);

    SSFuncionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSFuncion'];

    function SSFuncionDetailController($scope, $rootScope, $stateParams, previousState, entity, SSFuncion) {
        var vm = this;

        vm.sSFuncion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSFuncionUpdate', function(event, result) {
            vm.sSFuncion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
